<template>
    <div>
        <div class="ebc-dialog" :class="{ 'ebc-dialog-show': visible }">
            <span class="iconfont icon-close ebc-dialog-close-btn" @click="close"></span>
            <div class="ebc-dialog-header" v-if="title">
                <div class="ebc-dialog-title">{{ title }}</div>
            </div>
            <div class="ebc-dialog-content">
                <slot></slot>
            </div>
        </div>
        <div class="ebc-dialog-bg" :class="{ 'ebc-dialog-bg-show': visible }" @click="close"></div>
    </div>
</template>

<script>
function clearPopupData(scrollPosition) {
    // 恢复滚动
    document.body.classList.remove("body-no-scroll");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("padding-right");

    // 立即跳转到原位置(无动画)
    window.scrollTo({
        top: scrollPosition,
        behavior: "instant",
    });

    // 移除移动端触摸事件监听
    document.removeEventListener("touchmove", preventTouchScroll);
}
// 阻止移动端触摸滚动
function preventTouchScroll(e) {
    if (e.target === document.body || e.target === document.documentElement) {
        e.preventDefault();
    }
}
// 获取滚动条宽度
function getScrollbarWidth() {
    // 创建测量元素
    const scrollDiv = document.createElement("div");
    scrollDiv.style.width = "100px";
    scrollDiv.style.height = "100px";
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    document.body.appendChild(scrollDiv);

    // 计算宽度差
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // 移除测量元素
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
}
export default {
    name: "ebc-dialog",
    props: {
        title: {
            type: String,
            default: ""
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            scrollPosition: 0,
            scrollbarWidth: 0
        }
    },
    methods: {
        show() {
            console.log("show")
            this.scrollbarWidth = getScrollbarWidth()
            // 记录当前滚动位置
            this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            // 禁止滚动并处理滚动条
            document.body.classList.add("body-no-scroll");
            document.body.style.top = `-${this.scrollPosition}px`;

            // 补偿滚动条宽度，防止页面跳动
            if (this.scrollbarWidth > 0) {
                document.body.style.paddingRight = `${this.scrollbarWidth}px`;
            }

            // 处理移动端触摸事件
            document.addEventListener("touchmove", preventTouchScroll, {
                passive: false,
            });
            this.$emit("update:visible", true);
        },
        close() {
            clearPopupData(this.scrollPosition);
            this.$emit("update:visible", false);
        }
    },
    // beforeDistory() {
    //     clearPopupData(this.scrollPosition);
    // },
    mounted() {

    }
}
</script>
<style lang="scss">
// .barca2526 {
//     .navigate-wrapper {
//         z-index: 999999 !important;
//     }
// }
</style>
<style scoped>
.body-no-scroll {
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
}

.ebc-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 100vh);
    opacity: 0;
    padding: 24rem 24rem 24rem 48rem;
    background-color: #fff;
    z-index: 9000000000;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
    border-radius: var(--Corner-Radius-RC12, 12rem);
    width: 500rem;
    font-size: 16rem;
}

.ebc-dialog.ebc-dialog-show {
    transform: translate(-50%, -50%);
    opacity: 1;
}

.ebc-dialog-header {
    position: relative;
    /* padding: 0 30rem 0 0; */
    margin-right: 30rem;
}

.ebc-dialog-title {
    color: var(--Text-Primary, #000);
    font-size: 32rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.25;
}

.ebc-dialog .ebc-dialog-close-btn {
    position: absolute;
    right: 32rem;
    top: 32rem;
    font-size: 26rem;
    color: #858585;
    cursor: pointer;
    z-index: 99999999999999999;
}

.ebc-dialog-content {
    width: 100%;
    height: 400rem;
    overflow-y: auto;
    padding-right: 10rem;
}

.ebc-dialog-bg {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.64);
    z-index: 999999999;
}

.ebc-dialog-bg.ebc-dialog-bg-show {
    display: block;
}

/* 整个滚动条 */
.ebc-dialog-content::-webkit-scrollbar {
    width: 6rem;
    /* 竖向滚动条宽度 */
    height: 6rem;
    /* 横向滚动条高度 */
}

/* 滚动条轨道 */
.ebc-dialog-content::-webkit-scrollbar-track {
    background: #f2f2f2;
    border-radius: 3rem;
}

/* 滚动条滑块 */
.ebc-dialog-content::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 3rem;
}

/* 滚动条滑块悬停状态 */
.ebc-dialog-content::-webkit-scrollbar-thumb:hover {
    background: #dddddd;
}

@media (max-width: 996px) {
    .ebc-dialog {
        padding: 64rem 62rem 96rem;
        width: 100vw;
        flex-direction: column;
        align-items: center;
        gap: 64rem;
        position: fixed;
        top: unset;
        bottom: 0;
        left: 0;
        transform: translate(0, 100%);
        border-radius: 48rem 48rem 0 0;
        transition: all 0.3s ease-out;
    }

    .ebc-dialog.ebc-dialog-show {
        transform: translate(0, 0);
        opacity: 1;
    }

    .ebc-dialog .ebc-dialog-close-btn {
        font-size: 32rem;
    }
}
</style>